<template>
    <div class="employee-tab-inner">     
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="" id="">
                {{checkFFLimit}}
                 <b-tabs tab-class="nav-item-trustee" content-class="mt-4" nav-wrapper-class="trustee-nav-wrapper mt-4">
                    <template v-slot:tabs-start>
                        <b-nav-item disabled href="#" class="trustee-nav-first-wrapper">
                            <div class="trustee-nav-first">
                                <div class="trustee-nav-head">Distribution</div>
                                <div class="trustee-nav-subhead">Distribution summary for profit.</div>
                            </div>
                        </b-nav-item>
                    </template> 
                    <b-tab lazy active title-item-class="trustee-nav">
                       
                            <template #title>
                                <div class="trustee-report-title">
                                    <img v-bind:src="$api_url+'/images/table_chart.svg'" class="trustee-tab-icon"/>
                                    <div class="text">Profit Distribution</div>
                                </div>
                                <div class="trustee-report-intro">
                                    Profit Distribution History among PF Registered Employees.
                                </div>
                            </template>
                            <div class="trustee-tab-wrapper">
                                <pf-reclaim-list-front :pf_settings="pf_settings" :pageurl="pageurl" :distribution_type="1" :key="profit_list_key"></pf-reclaim-list-front>
                            </div>
                        
                    </b-tab>                 
                </b-tabs>
            </div>
        </b-overlay>
    </div>
</template>
<script>
    import moment from 'moment';

    export default{
        
        mounted() {
            if(this.employeedata.date_of_birth == '0000-00-00')
                this.fdata.date_of_birth = '';
            
            if(this.employeedata.last_working_day == '0000-00-00')
                this.fdata.last_working_day = '';
            
            this.showoverlay = false;
        },
        props: ['flg','pageurl'],

        data(){            
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);
            return {
                date_min:minDate,
                distribution_fdata : 
                {
                    profit_amount:"", 
                    profit_date: "", 
                    profit_details : "", 
                    distribution_type: 1,
                },
                forfeiture_fdata:
                {
                    distribution_type:2,
                    forfeiture_amount:"",
                    forfeiture_date:"",
                    forfeiture_details:"",
                },
                forfeiture_reclaim_data:
                {
                    reclaim_amount:"",
                    reclaim_date :"",
                    reclaim_details: "",
                    distribution_type:3,
                },
                f_y: ['2013-2014','2014-2015','2015-2016','2016-2017','2017-2018','2018-2019','2019-2020','2020-2021','2021-2022','2022-2023'],
                months: [
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],

                profit_distribution_type:null,
                // Sepicific Fiscal Year
                profit_fiscal_year:'',
                // Specific Month
                profit_specific_year:'',
                profit_specific_month:'',

                // Specifict Month Range 

                profit_specific_range_from_year:'',
                profit_specific_range_from_month:'',
                profit_specific_range_to_year:'',
                profit_specific_range_to_month:'',


                componentKey: 0,
                     
                cu:window.location.href,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : true,

                readonly : false,
                trz_display_form : 'd-none',
                user_level : 0,
                has_changed : false,
                reset_flg : false,
                has_changed_flg : false,

                tab_one_error : false,
                tab_two_error : false,
                tab_three_error : false,
                disableme : false,
                disabled : false,

                formatted: '',
                selected: '',
               
                profit_distribution_type_options:[
                    { value: null, text: "Please Select ..." },
                    { value: "1", text: "Fiscal Year" },
                    { value: "2", text: "Specific Month" },
                    { value: "3", text: "Month Range" },
                ],


                fake : 0,

                date_of_birth : '',
                date_of_joining : '',
                total_ff_fund:0,

                errormsg:[],
                
                fdata: {
                            employee_id:0, 
                            company_id:1, 
                            name:null,
                            email: null,                             
                            residency:null , 
                            gender:null , 
                            marital_status:'' , 
                            department_id:null , 
                            leave_policy_id: 0 , 
                            jobposition_id:null, 
                            branch_id:null,
                            manager_id:0,
                            
                            nid:'',
                            passport:'',
                            etin:'',
                            address:'',
                            emergency_contact:'',
                            beneficiary_name:'',
                            employee_code:'',
                            pic:'demo.jpg',   
                            draft_flg  : 0,   
                        },
                        pf_settings :{pf_year_end:{ opt_value: 0, status: 0 },},

                xdata : {
                    
                },
                employeedata:[],
                edit_user:false,
                new_capability:true,
                
                department : [],                
                jobposition : [],
                branch : [],
                manager : [],
                leave_policies : [],

                employee_pic : '',
                form_pic:null,
                form_nid_scan:null,
                form_etin_scan:null,

                
                form_passport_scan:null,

                residency: [
                    { value: null, text: "Select..." },
                    { value: "Resident", text: "Resident" },
                    { value: "Non Resident", text: "Non Resident" }
                ],
                nationality: [
                    { value: null, text: "Select..." },
                    { value: "Bangladeshi", text: "Bangladeshi" },
                    { value: "Non Bangladeshi", text: "Non Bangladeshi" }
                ],
                gender:[
                    { value: null, text: "Select..." },
                    { value: "Male", text: "Male" },
                    { value: "Female", text: "Female" },
                    { value: "Third Gender", text: "Third Gender" },
                ],
                marital_status:[
                    { value: '', text: "Select..." },
                    { value: "Single", text: "Single" },
                    { value: "Married", text: "Married" },
                    { value: "Widower", text: "Widower" },
                    { value: "Divorced", text: "Divorced" },
                ],

                bankurl : '/bankinfo/',  
                
                logoUrl : '/images/employee/' + 'demo.jpg',
                logoUploaded: false,
                showLogoUploader: false,
                
                /****new vars ***/
                profit_amount: 0,
                profit_date: '',
                profit_details: '',
                forfeiture_amount: 0,
                forfeiture_date: '',
                forfeiture_details: '',
                reclaim_amount: 0,
                reclaim_date: '',
                reclaim_details: '',
                list_key:0,
                profit_list_key:0,
                ff_list_key:0,
                forfeiture_reclaim_form_disable :false,
                forfeiture_distribution_form_disable :false,
                showoverlayprofit:false,
            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('DD/MM/YYYY');
            },
            maxStartDate: function() {
                return moment()
                    .startOf('month')
                    .add(1, 'months')
                    .endOf('month').format('DD/MM/YYYY');
            },
            showProfitDistributeForm: function()
            {
                this.$bvModal.show('bv-modal-profit-distribution');

                

                
            },
            showMessage: function()
            {
                let childdata = {employee_id:this.fdata.employee_id , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg};                    
                this.$emit('childToParent', childdata);
            },
            onContext(ctx) {
                // The date formatted in the locale, or the `label-no-date-selected` string
                //this.formatted = ctx.selectedFormatted;
                // The following will be an empty string until a valid date is entered
                //this.selected = ctx.selectedYMD;
                this.fake = this.fake + 1;
            },
            getUserLevel: function()
            {
                
                let currentObj = this;
                axios.get(this.$api_url+'/user-level')
                    .then(function (response) {
                        this.user_level = response.data;
                        
                    }.bind(this)).catch(function (error){ currentObj.serverError(error); });
            },
           
            trz_display: function()
            {
                this.trz_display_form = '';
                this.readonly = !this.readonly;
            },
            toggleLogoUploader() {
				this.showLogoUploader = !this.showLogoUploader;
			},            
			cropSuccess(imgDataUrl, field){
				
				this.logoUrl = imgDataUrl;
                this.logoUploaded = true;
			},
            getEmployee: function(reset = 0 , flg = 1){
                if(!this.checkNet()) return false;
                let currentObj = this;               

                // if user level is officer always show the 
                /*let flg = 0;
                if(reset == 0)
                {
                    if(this.user_level > 3)
                        flg = 1;
                }*/
                                

                axios.get(this.$api_url+'/employee/details?flg='+flg+'&reset='+reset)
                    .then(function (response) {

                        if(response.data.employee_id > 0)
                        {              
                                                        
                            for (let [key, value] of Object.entries(response.data))
                            {
                                this.xdata[key] = value;
                                this.fdata[key] = value;
                            }

                            
                            if((response.data.phone != null) && (response.data.phone != ''))
                            {
                                let p = response.data.phone;
                                this.fdata.phone = response.data.phone.slice(3,15);
                                this.xdata.phone = p.slice(3,15);
                            }                            

                            this.date_of_birth = moment(String(response.data.date_of_birth)).format('D MMMM YYYY');
                            this.date_of_joining = moment(String(response.data.date_of_joining)).format('D MMMM YYYY');

                            
                            this.logoUrl = '/images/employee/'+ this.fdata.company_id + '/' + this.fdata.pic;                            
                            this.disableme = true;                            
                            this.showMessage(); 

                            if(this.fdata.email == 'null'){ this.fdata.email = ''; this.xdata.email = ''; } 
                            if(this.fdata.passport == 'null'){ this.fdata.passport = ''; this.xdata.passport = ''; } 
                            if(this.fdata.emergency_contact == 'null'){ this.fdata.emergency_contact = ''; this.xdata.emergency_contact = ''; } 
                            if(this.fdata.employee_code == 'null'){ this.fdata.employee_code = ''; this.xdata.employee_code = ''; } 
                            if(this.fdata.etin == 'null'){ this.fdata.etin = ''; this.xdata.etin = ''; } 
                            if(this.fdata.marital_status == 'null'){ this.fdata.marital_status = ''; this.xdata.marital_status = ''; } 

                                                
                            this.edit_user = true;

                            if(this.fdata.draft_flg == 1)
                            {
                                this.has_changed_flg = true;
                                this.reset_flg = true;
                            }
                                

                            if(reset == 1)
                            {
                                this.reset_flg = false;
                                this.has_changed_flg = true;
                            }
                                
                            
                            this.form_pic = null;
                            this.form_nid_scan = null;
                            this.form_etin_scan = null;
                            
                            this.new_capability = true;
                            this.errormsg = [];
                            this.$validator.reset();
                            
                            this.readonly = true;
                            this.trz_display_form = 'd-none';

                        }else{
                           if(response.data.capability==false){
                            this.new_capability = false;
                            this.errormsg = [];
                            this.errormsg[0] = ["You are not allowed to add more employee!!!"];  
                           }
                           else{

                            this.readonly = false;
                            this.trz_display_form = '';

                            this.new_capability = true;
                            this.errormsg = [];
                           }
                           
                        }                            

                    }.bind(this)).catch(function (error){ currentObj.serverError(error); });
            },
       
           

           

          
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.getTotalForfeitureFund();
                this.forfeiture_reclaim_form_disable =false;
                this.forfeiture_distribution_form_disable =false;

                this.profit_distribution_type= null;
                // Sepicific Fiscal Year
                this.profit_fiscal_year= '';
                // Specific Month
                this.profit_specific_year= '';
                this.profit_specific_month= '';

                // Specifict Month Range 

                this.profit_specific_range_from_year= '';
                this.profit_specific_range_from_month= '';
                this.profit_specific_range_to_year= '';
                this.profit_specific_range_to_month = '';

               this.distribution_fdata =
                {
                    profit_amount:"", 
                    profit_date: "", 
                    profit_details : "",
                    distribution_type: 1, 
                },
                this.forfeiture_fdata =
                {
                    forfeiture_amount:"",
                    forfeiture_date:"",
                    forfeiture_details:"",
                    distribution_type:2,
                },
                this.forfeiture_reclaim_data=
                {
                    reclaim_amount:"",
                    reclaim_date :"",
                    reclaim_details: "",
                    distribution_type:3,
                    

                },

                this.reset_flg = true;

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;

                this.tab_one_error = false;
                this.tab_two_error = false;
                this.tab_three_error = false;

                this.has_changed = false;
                
                this.$validator.validate().then(result => {
                    if (!result) {

                        if(this.veeErrors.first('profit_amount'))
                        {
                            this.tab_one_error = true;
                        }
                        if(this.veeErrors.first('forfeiture_amount') || this.veeErrors.first('forfeiture_date') )
                        {
                            this.tab_two_error = true;
                        }
                        

                        this.$bvToast.toast("Please fill all required fields [marked red]", {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });
                        
                        return;
                    }
                    

                    e.preventDefault();  
                    let currentObj = this;
                    currentObj.errormsg = '';
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }                 

                    let formData = new FormData();

                    if(this.logoUploaded)
                        formData.append('form_pic', this.logoUrl);
                                        
                    if(this.form_nid_scan)
                        formData.append('form_nid_scan', this.form_nid_scan);
                    
                    if(this.form_etin_scan)
                        formData.append('form_etin_scan', this.form_etin_scan);


                    if(this.form_passport_scan)
                        formData.append('form_passport_scan', this.form_passport_scan);
                    
                    
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        if(fval == 'null')
                            fval = '';
                        formData.append(nm, fval);                    
                        if(this.fdata[key] != this.xdata[key])
                            this.has_changed = true;
                        
                    }
                    
                    if(this.has_changed_flg)
                        this.has_changed = true;

                    if(this.has_changed == false)
                    {
                        /*this.$bvToast.toast('No changes found.', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });

                        return;*/
                    }
                        
                    this.showoverlay = true;

                    axios.post(this.$api_url+'/employee/account', formData, config)
                                .then(function (response) 
                                {
                                    this.showoverlay = false;

                                    if(response.data.status == 0)
                                    {
                                        this.$bvToast.toast(response.data.msg, {
                                            title: `error`,
                                            variant: 'danger',
                                            solid: true
                                        });
                                    }
                                    else
                                    {
                                        this.$bvToast.toast("Saved!", {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                        this.disableme = true;
                                        this.edit_user = true;

                                        if(this.reset_flg == true)
                                            this.reset_flg = false
                                                                                
                                        
                                        this.fdata = response.data.employee_info;
                                        this.fdata.phone = response.data.employee_info.phone.slice(3,15);

                                        if(this.fdata.email == 'null') this.fdata.email = '';
                                        
                                        if(this.fdata.passport == 'null') this.fdata.passport = '';
                                        if(this.fdata.emergency_contact == 'null') this.fdata.emergency_contact = '';
                                        if(this.fdata.employee_code == 'null') this.fdata.employee_code = '';

                                        this.showMessage();

                                        this.showoverlay = false;

                                        this.readonly = true;
                                        this.trz_display_form = 'd-none';
                                    }                                    
                                    
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                                    
                                    currentObj.showoverlay = false;
                                    currentObj.serverError(error);

                                });
                });
            },

            // on Submit distribution form start
        
            onSubmitDistributeForm()
            {                
                this.$validator.validate().then(result =>
                {
                    if (!result) 
                    {
                        return;
                    }
                    let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.distribution_fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }

                    formData.append('profit_distribution_type', this.profit_distribution_type);

                    if(this.profit_distribution_type == 1)
                    {
                        // Sepicific Fiscal Year
                        formData.append('profit_fiscal_year', this.profit_fiscal_year);
                    }
                    else if(this.profit_distribution_type == 2)
                    {
                        // Specific Month
                        formData.append('profit_specific_year', this.profit_specific_year);
                        formData.append('profit_specific_month', this.profit_specific_month);

                    }
                    else if (this.profit_distribution_type == 3)
                    {
                        // Specifict Month Range 
                        formData.append('profit_specific_range_from_year', this.profit_specific_range_from_year);
                        formData.append('profit_specific_range_from_month', this.profit_specific_range_from_month);
                        formData.append('profit_specific_range_to_year', this.profit_specific_range_to_year);
                        formData.append('profit_specific_range_to_month', this.profit_specific_range_to_month);

                    }
                    this.showoverlayprofit = true;
                    axios.post(this.$api_url+'/pf/distribute-profit/save', formData)
                        .then(function (response)
                        {
                            this.showoverlayprofit = false;
                            console.log(response.data);
                            if(response.data.success)
                            {
                                this.$bvToast.toast(response.data.success, {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                                });

                                this.$bvModal.hide('bv-modal-profit-distribution');
                            }
                            else if(response.data.error)
                            {
                                this.$bvToast.toast(response.data.error, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                                });
                            }

                            this.resetForm();
                            this.componentKey += 1;
                            this.profit_list_key = this.profit_list_key + 1;

                        }.bind(this))
                        .catch(function (error)
                        {
                            this.showoverlay = false;
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                            for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                    currentObj.$validator.reset();
                                }
                        });
                });
            },
            // on Submit distribution form End

            // on Submit distribution Reclaim form start
            onSubmitDistributeForfeitureForm()
            {
              this.$validator.validate().then(result =>
                {
                    if (!result) 
                    {
                        return;
                    }
                     let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.forfeiture_fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }
                    this.showoverlay = true;
                    axios.post(this.$api_url+'/pf/distribute-forfeiture/save', formData)
                        .then(function (response)
                        {
                            this.showoverlay = false;
                            if(response.data.success)
                            {
                                this.$bvToast.toast(response.data.success, {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                                });
                            }
                            else if(response.data.error)
                            {
                                this.$bvToast.toast(response.data.error, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                                });
                            }
                            this.ff_list_key = this.ff_list_key + 1;
                            this.resetForm();
                        
                            
                        }.bind(this))
                        .catch(function (error)
                        {
                            this.showoverlay = false;
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                            for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                    currentObj.$validator.reset();
                                }
                        });

                });
               
            },

            // on Submit distribution Reclaim form start
            onSubmitDistributeReclaimForm()
            {
                this.$validator.validate().then(result =>
                {
                    if (!result) 
                    {
                        return;
                    }
                let currentObj = this;

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.forfeiture_reclaim_data))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }
                    this.showoverlay = true;
                    axios.post(this.$api_url+'/pf/distribute-forfeiture-reclaim/save', formData)
                        .then(function (response)
                        {
                            this.showoverlay = false;
                            if(response.data.success)
                            {
                                this.$bvToast.toast(response.data.success, {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                                });
                            }
                            else if(response.data.error)
                            {
                                this.$bvToast.toast(response.data.error, {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                                });
                            }
                            this.list_key = this.list_key + 1;
                            this.resetForm();
                        }.bind(this))
                        .catch(function (error)
                        {
                            this.showoverlay = false;
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                            for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                    currentObj.$validator.reset();
                                }
                        });
                    });
            },
            getTotalForfeitureFund: function() {
                
                axios.get(this.$api_url+'/pf/get-forfeiturerefund',{
              }).then(function(response){
                 if(response.data.total_ff_fund > 0)
                 {
                     this.total_ff_fund = response.data.total_ff_fund;
                 }
                 
                }.bind(this));
            },
            getPFSettings: function()
            { 
                let currentObj = this;
                axios.get(this.$api_url+'/pf/settings').then(function (response) {
                    currentObj.pf_settings = response.data.data;
                    console.log(currentObj.pf_settings);   
                }.bind(this));

            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }
                
            //     return money;
            // },  
        },
        computed: 
        {
            checkFFLimit()
            {
                if(this.forfeiture_fdata.forfeiture_amount > this.total_ff_fund)
                {
                    this.forfeiture_distribution_form_disable =true;
                }
                else
                {
                    this.forfeiture_distribution_form_disable =false;
                }


                if(this.forfeiture_reclaim_data.reclaim_amount > this.total_ff_fund)
                {   
                     this.forfeiture_reclaim_form_disable =true;
                }
                else
                {
                    this.forfeiture_reclaim_form_disable =false;
                };
            },
            years () 
            {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2018}, (value, index) => year - index)
            },
            
        },
        created: function(){
            if(!this.checkNet()) return false;
            this.getPFSettings();
            this.getTotalForfeitureFund();
            this.getUserLevel();
            this.$validator.reset();
        }
    }
</script> 
<style>
.showoverlayprofit .b-overlay {
	height: 100%;
}
</style>